import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import { CodeSurfer, CodeSurferColumns, Step } from "code-surfer";
import { github, nightOwl, vsDark } from "@code-surfer/themes";
const styledCenter = {
  width: "fit-content",
  textAlign: "center",
  borderBottom: '10px solid',
  borderImageSource: "linear-gradient(120deg, #1890ff, #db18ff)",
  borderImageSlice: 5
};
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <CodeSurferColumns sizes={[1, 2]} themes={[nightOwl]} mdxType="CodeSurferColumns">
      <Step mdxType="Step">
        <div style={styledCenter}>
          <h1>useReducer</h1>
          <p>Old <code>setState</code></p>
        </div>
        <pre><code parentName="pre" {...{
            "className": "language-jsx"
          }}>{`
const reducer = (prevState, 
updatedProperty) => 
({
  ...prevState,
  ...updatedProperty,
});

const initState = {
  name: 'Bob',
  age: 25,
};

const [state, setState]= useReducer(
                      reducer, initState)
                      ;

setState({ name: 'Alice' });

//updated state:
state = {
  name: 'Alice',
  age: 25,
};
`}</code></pre>
      </Step>
      <Step mdxType="Step">
        <div style={styledCenter}>
          <h1>useReducer</h1>
          <p>Usage with useContext</p>
        </div>
        <pre><code parentName="pre" {...{
            "className": "language-jsx"
          }}>{`const TodosDispatch = React.createContext(null);

function TodosApp() {
  // Note: \`dispatch\` won't change between re-renders
  const [todos, dispatch] = useReducer(todosReducer);

  return (
    <TodosDispatch.Provider value={dispatch}>
      <DeepTree todos={todos} />
    </TodosDispatch.Provider>
  );
}
`}</code></pre>
      </Step>
      <Step mdxType="Step">
        <div style={styledCenter}>
          <h1>useReducer</h1>
          <p>Usage with useContext</p>
        </div>
        <pre><code parentName="pre" {...{
            "className": "language-jsx",
            "metastring": "2,3",
            "2,3": true
          }}>{`function DeepChild(props) {
  // If we want to perform an action, we can get dispatch from context.
  const dispatch = useContext(TodosDispatch);

  function handleClick() {
    dispatch({ type: 'add', text: 'hello' });
  }

  return (
    <button onClick={handleClick}>Add todo</button>
  );
}
`}</code></pre>
      </Step>
    </CodeSurferColumns>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      